/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseInteger
 */
export interface ResponseInteger {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseInteger
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseInteger
     */
    message?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseInteger
     */
    data?: number;
}

/**
 * Check if a given object implements the ResponseInteger interface.
 */
export function instanceOfResponseInteger(value: object): value is ResponseInteger {
    return true;
}

export function ResponseIntegerFromJSON(json: any): ResponseInteger {
    return ResponseIntegerFromJSONTyped(json, false);
}

export function ResponseIntegerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseInteger {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function ResponseIntegerToJSON(json: any): ResponseInteger {
    return ResponseIntegerToJSONTyped(json, false);
}

export function ResponseIntegerToJSONTyped(value?: ResponseInteger | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'],
    };
}

